import React, { memo } from 'react';
import { LayoutGridIcons, TableIcons } from '../../../../../../icons/icons';
import { ViewModeToggleProps } from './interfaces';

export const ViewModeToggle = memo<ViewModeToggleProps>(
  ({ viewMode, setViewMode }) => (
    <div className='flex items-center gap-0.5 rounded-lg border border-slate-200 bg-slate-100/70 p-0.5'>
      <button
          onClick={() => setViewMode('table')}
          className={`min-h-8 rounded-md px-2 transition-all duration-300 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap ${
            viewMode === 'table'
              ? 'bg-slate-200 text-slate-900 shadow-sm'
              : 'text-slate-500 hover:text-slate-900 hover:bg-slate-100/60'
          }`}
          title='Table view'
          aria-label='Switch to table view'
          aria-pressed={viewMode === 'table'}
      >
        <TableIcons className='w-3 h-3' />
        <span className='hidden lg:block'>Table</span>
      </button>
      <button
          onClick={() => setViewMode('grid')}
          className={`min-h-8 rounded-md px-2 transition-all duration-300 flex items-center gap-1.5 text-xs font-semibold whitespace-nowrap ${
            viewMode === 'grid'
              ? 'bg-slate-200 text-slate-900 shadow-sm'
              : 'text-slate-500 hover:text-slate-900 hover:bg-slate-100/60'
          }`}
          title='Chart view'
          aria-label='Switch to chart view'
          aria-pressed={viewMode === 'grid'}
      >
        <LayoutGridIcons className='w-3 h-3' />
        <span className='hidden md:block'>Charts</span>
      </button>
    </div>
  ),
);

ViewModeToggle.displayName = 'ViewModeToggle';
